import React from 'react';

interface ISingleResultRow {
  hit: any;
  setShowFullRecord: any;
  showFilters: boolean;
  isSelected?: boolean;
  onSelect?: any;
}

const ProductRow: React.FC<ISingleResultRow> = ({
  showFilters,
  hit,
  setShowFullRecord,
  isSelected = false,
  onSelect,
}) => {
  const handleShowFullRecord = (fullHit: any) => {
    if (onSelect) {
      onSelect(fullHit);
      return;
    }
    setShowFullRecord({ show: true, record: fullHit });
  };

  return (
    <div
      className={`screening-results-row${
        isSelected ? ' product-screening-selected-row' : ''
      }`}
      onClick={() => handleShowFullRecord(hit)}
      style={{
        ...(isSelected
          ? {
              backgroundColor: 'rgba(72, 149, 239, 0.12)',
              borderLeft: '3px solid var(--action-color)',
            }
          : {
              borderLeft: '3px solid transparent',
            }),
      }}
    >
      <div className='screening-results-row-checkbox-cell'>
        {/* add checkbox later */}
      </div>
      <div className='screening-results-row-default-cell'>
        <div className='screening-results-row-default-cell-inner'>
          <div className='screening-results-row-link-cell-text'>
            {hit?._source['Product Name']}
          </div>
        </div>
      </div>
      <div className='screening-results-row-default-cell'>
        <div className='screening-results-row-default-cell-inner'>
          <div className='screening-results-row-default-cell-text'>
            {hit?._source['HS Code']}
          </div>
        </div>
      </div>
      <div className='screening-results-row-default-cell'>
        <div className='screening-results-row-default-cell-inner'>
          <div className='screening-results-row-default-cell-text'>
            {hit?._source['List Name']}
          </div>
        </div>
      </div>
      {!showFilters && (
        <>
          <div className='screening-results-row-default-cell'>
            <div className='screening-results-row-default-cell-inner'>
              <div className='screening-results-row-default-cell-text'>
                {hit?._source.Agency}
              </div>
            </div>
          </div>
          <div className='screening-results-row-default-cell'>
            <div className='screening-results-row-default-cell-inner'>
              <div className='screening-results-row-default-cell-text'>
                {hit?._source['Source Country']}
              </div>
            </div>
          </div>
          <div className='screening-results-row-default-cell'>
            <div className='screening-results-row-default-cell-inner'>
              <div className='screening-results-row-default-cell-text'>
                {hit?._source['Date Updated on BITE Platform']}
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default ProductRow;
